import { MessageSquare } from "lucide-react";
import { openFeedbackSurvey } from "@/lib/posthog";
import { cn } from "@/lib/utils";

type FeedbackButtonProps = {
  collapsed?: boolean;
};

// Sidebar-footer "Feedback" entry point. Opens PostHog's feedback survey
// (popover) on click — PostHog owns the form and stores the responses.
// Collapses to an icon when the sidebar is collapsed, matching the UserMenu
// it sits above.
export function FeedbackButton({ collapsed = false }: FeedbackButtonProps) {
  return (
    <button
      type="button"
      onClick={openFeedbackSurvey}
      aria-label="Feedback"
      title={collapsed ? "Feedback" : undefined}
      className={cn(
        "flex items-center gap-2 rounded-md text-small text-fg-2 transition-colors hover:bg-bg-3 hover:text-fg-1",
        collapsed ? "w-9 h-9 mx-auto justify-center" : "w-full px-2 py-1.5",
      )}
    >
      <MessageSquare
        size={14}
        strokeWidth={1.7}
        className="shrink-0 opacity-85"
      />
      {!collapsed ? <span>Feedback</span> : null}
    </button>
  );
}
